import type { CartFormPayload } from '@/types/api'
import clsx from 'clsx'

export function cn(...classes: Array<string | boolean | null | undefined>) {
  return clsx(classes)
}

export function getCookie(name: string) {
  const cookie = document.cookie
    .split('; ')
    .find((chunk) => chunk.startsWith(`${name}=`))

  return cookie ? decodeURIComponent(cookie.split('=')[1]) : ''
}

export function formatMoney(value?: number | null) {
  if (value == null || Number.isNaN(value)) {
    return '—'
  }

  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 2,
  }).format(value)
}

export function formatDate(value?: string | null) {
  if (!value) {
    return '—'
  }

  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(value))
}

export function formatDateTime(value?: string | null) {
  if (!value) {
    return '—'
  }

  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

export function toFormData(
  values: Record<string, unknown>,
  cartData?: CartFormPayload | Record<string, number>,
) {
  const formData = new FormData()

  Object.entries(values).forEach(([key, value]) => {
    if (value == null) {
      return
    }

    if (typeof FileList !== 'undefined' && value instanceof FileList) {
      const file = value.item(0)
      if (file) {
        formData.append(key, file)
      }
      return
    }

    if (typeof File !== 'undefined' && value instanceof File) {
      formData.append(key, value)
      return
    }

    formData.append(key, String(value))
  })

  if (cartData) {
    formData.append('cart_data', JSON.stringify(cartData))
  }

  return formData
}
